// extracted by mini-css-extract-plugin
module.exports = {"container":"product-select-field__container___3mV_i","market":"product-select-field__market___381l1"};